import { getEnv, getCsrfToken, RestHandler } from '@ctct/ctct-helpers';

const getBaseUrl = () => {
  if (getEnv() === 'local') {
    return 'https://localhost:9000/v1/settings';
  }

  return `https://app${getEnv()}constantcontact.com/v1/settings`;
};

const options = { headers: {} };
const token = getCsrfToken();

if (getEnv() !== 'local') {
  options.headers['X-CSRF-Token'] = token;
}

const restHandler = new RestHandler(getBaseUrl(), options);

const APPLICATION_ID = 'myaccount';
const getFeatureSetting = (settingName) =>
  restHandler.get(`/applications/${APPLICATION_ID}/accounts/features/${settingName}`);

const getAccountSetting = (settingName) =>
  restHandler.get(`/applications/${APPLICATION_ID}/accounts/settings/${settingName}`);

const setAccountSetting = (settingName, settingValue) =>
  restHandler.put(`/applications/${APPLICATION_ID}/accounts/settings/${settingName}`, settingValue);

export default {
  getFeatureSetting,
  getAccountSetting,
  setAccountSetting,
};
